import React from 'react';
import Header from '../components/Homepage/Header';
import Footer from '../components/Homepage/Footer';
import Form from '../components/Homepage/Form';

export default function Homepage() {
  return (
    <>
      <Header />
      <Form />
      <Footer />
    </>
  );
}
